import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../../axios';
import { moduleName } from '../../moduleInfo';
import { affiliateGeneratedLeadRoute } from '../../utils/apiRoutes';

export const getGeneratedLeadsAsync = createAsyncThunk(
  `${moduleName}/getGeneratedLeadsAsync`,
  async (payload) => {
    const { params } = payload;
    const response = await axios({
      method: 'GET',
      url: affiliateGeneratedLeadRoute(),
      params: { ...params },
    });
    const data = response.data;
    return data;
  }
);

const GeneratedSlice = createSlice({
  name: `${moduleName}/genleads`,
  initialState: {
    loading: false,
    reffercodes: [],
  },
  reducers: {},
  extraReducers: {
    [getGeneratedLeadsAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [getGeneratedLeadsAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.reffercodes = action.payload;
    },
    [getGeneratedLeadsAsync.rejected]: (state, action) => {
      state.loading = false;
    },
  },
});

export default GeneratedSlice.reducer;
